/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models{
    export class JsonDictionaryStoresModel {
        public systemLevel: Wars.Domain.Model.SystemLevel;
        public currentJsonDictionary: Wars.Domain.Model.JsonDictionaryStore;

        constructor(private systemLevelService: services.SystemLevelService) {
            systemLevelService.getSystemLevelJsonDictionaryStores().then(s => {
                this.systemLevel = s;
            });
        }

        public addJsonDictionaryStore() {
            this.currentJsonDictionary = <any>this.systemLevelService.createNewEntity("JsonDictionaryStore");
            this.currentJsonDictionary.name = "New Dictionary";
            this.systemLevel.myJsonDictionaryStores.push(this.currentJsonDictionary);

            this.systemLevelService.saveAllChanges();
        }

        public save() {
            this.systemLevelService.saveAllChanges();
        }

        public remove() {
            this.currentJsonDictionary.entityAspect.setDeleted();
            this.currentJsonDictionary = null;

            this.systemLevelService.saveAllChanges();
        }
    }
}